var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"btn",staticClass:"gBtn",attrs:{"role":"button"}},[_c('i',{staticClass:"gBtnIco"}),_c('span',{staticClass:"gBtnTxt"},[_vm._t("default",[_vm._v("Log in with Google")])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }